import { goldBuyingCalculator } from '@js/pages/gold-buying/goldBuyingCalculator';
import { openRemoteModal } from '@js/utilities/remoteModal';

['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
    window.addEventListener(ev, () => {
        goldBuyingCalculator();
    });
});

const goldBuyingStep1Form = document.querySelector('#gold-buying-calculator-form');

goldBuyingStep1Form?.addEventListener('submit', (e) => {
    e.preventDefault();

    const choosenTypeOfGold = document.querySelector('.js-gold-buying-calculator-type-of-gold');
    const choosenFineness = document.querySelector('.js-gold-buying-calculator-fineness');
    const weight = document.querySelector('.js-gold-buying-calculator-weight');
    const haveStones = document.querySelector('.js-gold-buying-calculator-have-stones');

    const urlParams = `type_of_gold=${choosenTypeOfGold.value}&fineness=${choosenFineness.value}&weight=${weight.value}&have_stones=${haveStones.checked}`;

    openRemoteModal(`/ajax/modals/gold-buying?${urlParams}`);
});

// openRemoteModal(
//     `/ajax/modals/gold-buying?type_of_gold=ring&fineness=585&weight=100&have_stones=true`
// );
